<cjm-layout-container
	class="c-vloket-page-header--content-wrapper"
	preventSpacing="top"
	[layoutType]="assetUrl ? 'split-equal' : 'full-width'"
>
	<ng-content main></ng-content>

	<div class="c-vloket-page-header--visual" asideRight [style.background-image]="'url(' + assetUrl + ')'"></div>
</cjm-layout-container>
